import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type PartnerLogo = {
  name: string
  /** Optional logo element; when omitted, a labeled placeholder is shown. */
  logo?: React.ReactNode
}

type PartnerLogoStripProps = {
  title?: string
  firms: PartnerLogo[]
  className?: string
}

function PartnerLogoStrip({
  title = 'Trusted by households navigating complex financial decisions',
  firms,
  className,
}: PartnerLogoStripProps) {
  return (
    <section data-slot="partner-logo-strip" className={cn('flex flex-col items-center gap-4', className)}>
      {title ? <p className="text-center text-body-bold text-foreground">{title}</p> : null}
      <ul className="flex flex-wrap items-center justify-center gap-3">
        {firms.map(({ name, logo }) => (
          <li
            key={name}
            className="flex h-14 min-w-28 items-center justify-center rounded-lg border border-border bg-card px-3 text-center text-body-xs font-medium text-muted-foreground shadow-sm"
          >
            {logo ?? name}
          </li>
        ))}
      </ul>
    </section>
  )
}

export { PartnerLogoStrip }
export type { PartnerLogoStripProps, PartnerLogo }
